module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.48d43795.svg";